import { type ReactNode } from 'react';

import { cn } from '@axioma/ui';

interface KpiTileProps {
  label: string;
  value: ReactNode;
  hint?: string;
  variant?: 'neutral' | 'aurora' | 'electric' | 'critical';
  pulse?: boolean;
}

const variantClasses = {
  neutral: 'text-ax-text-primary',
  aurora: 'text-ax-aurora',
  electric: 'text-ax-electric',
  critical: 'text-ax-critical',
} as const;

export function KpiTile({ label, value, hint, variant = 'neutral', pulse }: KpiTileProps): JSX.Element {
  return (
    <div className="bg-ax-graphite border border-ax-line rounded-ax-lg px-5 py-4 min-w-0">
      <p className="ax-eyebrow text-ax-text-tertiary truncate">{label}</p>
      <p
        className={cn(
          'font-display text-3xl font-medium tracking-tighter mt-1.5',
          variantClasses[variant],
          pulse && 'animate-ax-pulse-critical',
        )}
      >
        {value}
      </p>
      {hint && (
        <p className="font-mono text-[10px] text-ax-text-tertiary uppercase tracking-wider mt-1 truncate">
          {hint}
        </p>
      )}
    </div>
  );
}
